import dayjs from "configs/dayjs.config";

export const calculateDaysLeft = (targetDate) => {
  const days = dayjs(targetDate)
    .startOf("day")
    .diff(dayjs().startOf("day"), "days");
  return days;
};

export const calculateDaysSince = (targetDate) => {
  const days = dayjs()
    .startOf("day")
    .diff(dayjs(targetDate).startOf("day"), "days");
  return days;
};
export const calculateDaysDiff = (sourceDate, targetDate) => {
  const days = dayjs(sourceDate)
    .startOf("day")
    .diff(dayjs(targetDate).startOf("day"), "days");
  return days;
};
